export { default as Chart } from './Chart'


//////////////////
// WEBPACK FOOTER
// ./~/vue-frappe-chart/src/components/index.js
// module id = 1150
// module chunks = 1